export default {
  zh: {
    name: '持卡人姓名',
    confirm: '确认支付',
    cardNameErrorMsg: '持卡人姓名不为空'
  },
  en: {
    name: "Cardholder's name",
    confirm: 'Pay Now',
    cardNameErrorMsg: 'Name is required'
  }
}



// WEBPACK FOOTER //
// ./src/components/stripe/lang.js